<azavista-exported-element-wrapper>
  <div class="grouped-fields-view-container aza-pa-flex-row aza-pa-content-space-between aza-pa-half-gap">
    @if (fieldsTitle) {
      <h3 class="grouped-fields-view-title">{{ fieldsTitle }}</h3>
    }
    <div class="aza-pa-flex-row aza-pa-half-gap">
      @if (viewFieldValue) {
        <azavista-input-field [field]="viewField" [value]="viewFieldValue"
          [editMode]="true" (valueChanged)="onViewValueChanged($event)" label="{{'SELECT_VIEW' | translate}}">
        </azavista-input-field>
      }
      @if (currentView) {
        <azavista-flat-button action="edit-view" [disabled]="!currentView.id"
          (click)="onCreateNewOrEditExistingClicked(false)" color="primary">
          <mat-icon class="material-icons-outlined">edit_outline</mat-icon>
          <span translate>EDIT_VIEW</span>
        </azavista-flat-button>
      }
      @if (canCreateView) {
        <azavista-flat-button action="create-view" (click)="onCreateNewOrEditExistingClicked(true)" color="primary">
          <mat-icon class="material-icons-outlined">add</mat-icon>
          <span translate>CREATE_VIEW</span>
        </azavista-flat-button>
      }
    </div>
  </div>
</azavista-exported-element-wrapper>
